"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const R = __importStar(require("ramda"));
const apollo_link_1 = require("apollo-link");
const utils_1 = require("./utils");
/**
 * Token Refresh Link renew authentication token when it's expired.
 * @param {TokenRefreshLinkOptions} options - The token refresh link options.
 * @param {Function} options.onAuthSuccess - The callback which called when attempt to refresh authentication is success.
 * @param {Function} [options.onAuthError] - The callback which called when attempt to refresh authentication is failed.
 * @param {Function} [options.onIdTokenExpired] - The callback which called when id token is expired.
 */
class TokenRefreshLink extends apollo_link_1.ApolloLink {
    constructor({ onIdTokenExpired, onAuthError }) {
        super();
        this.onAuthError = onAuthError;
        this.onIdTokenExpired = onIdTokenExpired;
    }
    request(operation, forward) {
        return new apollo_link_1.Observable(observer => {
            let subscription = null;
            let handling = false;
            const handleTokenRefresh = () => {
                this.handleTokenExpired()
                    .then(() => {
                    const observable = forward(operation);
                    if (subscription) {
                        subscription.unsubscribe();
                    }
                    handling = false;
                    subscription = observable.subscribe(subscriber);
                })
                    .catch(err => {
                    this.handleAuthFailed(err);
                    handling = false;
                    observer.complete();
                });
            };
            const subscriber = {
                complete: () => {
                    if (!handling) {
                        observer.complete();
                    }
                },
                error: (error) => {
                    const batchedErrors = R.pathOr([error], ['response', 'parsed', 'errors'], error);
                    if (utils_1.hasIdTokenExpiredError(batchedErrors)) {
                        handling = true;
                        handleTokenRefresh();
                    }
                    else if (utils_1.hasRefreshTokenExpiredError(batchedErrors) || utils_1.hasTokenInvalidError(batchedErrors)) {
                        this.handleAuthFailed();
                    }
                    else {
                        observer.error(error);
                    }
                },
                next: (data) => {
                    const dataErrors = data.errors || [];
                    if (utils_1.hasIdTokenExpiredError(dataErrors)) {
                        handling = true;
                        handleTokenRefresh();
                    }
                    else if (utils_1.hasRefreshTokenExpiredError(dataErrors) || utils_1.hasTokenInvalidError(dataErrors)) {
                        this.handleAuthFailed();
                    }
                    else {
                        observer.next(data);
                    }
                },
            };
            subscription = forward(operation).subscribe(subscriber);
            return subscription;
        });
    }
    handleTokenExpired() {
        if (typeof this.onIdTokenExpired === 'function') {
            return this.onIdTokenExpired();
        }
        return Promise.reject();
    }
    handleAuthFailed(err) {
        if (typeof this.onAuthError === 'function') {
            this.onAuthError(err);
        }
    }
}
exports.TokenRefreshLink = TokenRefreshLink;
//# sourceMappingURL=TokenRefreshLink.js.map